module.exports = __webpack_public_path__ + "img/wire-3.a87f1723.jpg";